(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-next-growth]').forEach(root => {
      if (root.dataset.nextReady) return;
      root.dataset.nextReady = 'true';
      const desktop = matchMedia('(min-width: 801px)');
      root.querySelectorAll('.lng-choice > summary').forEach(summary => {
        summary.addEventListener('click', event => {
          if (desktop.matches && summary.parentElement.open) event.preventDefault();
        });
      });
      const ensureOpen = () => {
        if (desktop.matches && !root.querySelector('details[open]')) root.querySelector('details').open = true;
      };
      desktop.addEventListener('change', ensureOpen);
      ensureOpen();
    });
    scope.querySelectorAll('.lnp-grid').forEach(root => {
      if (root.dataset.nextReady) return;
      root.dataset.nextReady = 'true';
      const mobile = matchMedia('(max-width: 800px)');
      const phases = [...root.querySelectorAll('[data-next-phase]')];
      const group = phases[0]?.getAttribute('name');
      const sync = () => {
        phases.forEach((phase, i) => {
          if (mobile.matches) phase.setAttribute('name', group);
          else phase.removeAttribute('name');
          phase.open = !mobile.matches || i === 0;
          phase.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
        });
      };
      sync(); mobile.addEventListener('change', sync);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
